// Dati Quiz motivazionale — Prime Vision Extra (/extra)

export const SCALE_OPTIONS = [
  { value: 1, label: "Per niente" },
  { value: 2, label: "Poco" },
  { value: 3, label: "Abbastanza" },
  { value: 4, label: "Molto" },
  { value: 5, label: "Moltissimo" },
];

export const QUIZ_QUESTIONS = [
  { id: 1, motivation: "teorica", text: "Prima di scegliere o decidere, voglio capire bene il perché delle cose." },
  { id: 2, motivation: "utilitaristica", text: "Mi convincono soprattutto i vantaggi concreti, misurabili e utili." },
  { id: 3, motivation: "individualistica", text: "Mi piace avere autonomia, influenza e possibilità di guidare le decisioni." },
  { id: 4, motivation: "estetica", text: "Mi fido di più quando tutto appare armonioso, ordinato e piacevole." },
  { id: 5, motivation: "sociale", text: "Mi motiva sapere che una mia scelta può aiutare altre persone." },
  { id: 6, motivation: "tradizionale", text: "Mi rassicurano regole chiare, procedure e routine ben definite." },
  { id: 7, motivation: "teorica", text: "Mi piace approfondire, aggiornarmi e aumentare le mie conoscenze di settore." },
  { id: 8, motivation: "utilitaristica", text: "Mi interessa usare tempo, risorse e denaro in modo efficiente." },
  { id: 9, motivation: "individualistica", text: "Mi gratifica essere riconosciuto, apprezzato e considerato autorevole." },
  { id: 10, motivation: "estetica", text: "Lavoro meglio in un ambiente libero da conflitti, tensioni e disordine." },
  { id: 11, motivation: "sociale", text: "Collaborare e contribuire al benessere degli altri mi dà energia." },
  { id: 12, motivation: "tradizionale", text: "Preferisco lavorare secondo un metodo preciso, con punti saldi e sicurezza." },
];

export const ROLE_OPTIONS = [
  "Titolare di studio",
  "Oculista",
  "Segreteria / office manager",
  "Consulente",
  "Altro professionista sanitario",
];

export const RESULT_WARNING = "Questo risultato parla di te, non dei tuoi pazienti. Il punto strategico è questo: se comunichi solo secondo la tua motivazione dominante, rischi di non agganciare persone che decidono con leve diverse.";

export const RESULT_CTA_TEXT = "Per applicare questo metodo in uno studio puoi usare una piattaforma che profila il paziente, invia domande utili e propone appuntamenti coerenti con il suo percorso. Prime Vision nasce per questo tipo di organizzazione.";

export const MOTIVATION_RESULTS = {
  teorica: {
    label: "Teorica",
    intro: "Sei guidato dal desiderio di sapere. Prima di scegliere vuoi capire le cause, approfondire, aggiornarti e avere una spiegazione solida.",
    cosaFare: "Usa la tua chiarezza come forza, ma non trasformare ogni comunicazione in una lezione. Crea messaggi con un motivo chiaro e una sola azione.",
    cosaDire: "Il controllo serve a verificare se la situazione è stabile. Puoi confermare qui, oppure spostare se questo orario non è più comodo.",
    percezione: "Competente, chiaro, preparato. Attento però a non sembrare complessa quando il paziente ha bisogno solo di semplicità.",
  },
  utilitaristica: {
    label: "Utilitaristica",
    intro: "Sei guidato dai vantaggi concreti. Ti convincono risultati misurabili, risparmio di tempo, uso efficiente delle risorse, profitti o risparmi.",
    cosaFare: "Porta sempre il discorso sul beneficio pratico, ma non dimenticare che alcune persone non decidono solo per convenienza.",
    cosaDire: "Confermi da qui in pochi secondi. Se non riesci a venire, puoi spostare senza telefonare e senza perdere tempo.",
    percezione: "Pratico, efficiente, utile. Il rischio è sembrare troppo orientato al risultato e poco alla relazione.",
  },
  individualistica: {
    label: "Individualistica",
    intro: "Sei guidato dal desiderio di potere personale, autonomia e riconoscimento. Ti motivano prestigio, influenza, indipendenza e possibilità di guidare.",
    cosaFare: "Trasforma il controllo in leadership gentile. Dai opzioni, fai scegliere, ma non far percepire la comunicazione come una prova di forza.",
    cosaDire: "Puoi scegliere l'orario più adatto tra quelli disponibili. L'importante è che il percorso resti sotto controllo.",
    percezione: "Autorevole, deciso, moderno. Il rischio è sembrare dominante se davanti hai persone più tradizionali o sensibili.",
  },
  estetica: {
    label: "Estetica",
    intro: "Sei guidato dal desiderio di armonia. Cerchi ambienti senza conflitti, bellezza, equilibrio, tempo per riflettere e spazio per idee creative.",
    cosaFare: "Cura forma, tono e fluidità dell'esperienza. Ricorda però che l'armonia deve portare anche a un'azione concreta.",
    cosaDire: "Le abbiamo preparato tutte le informazioni utili per arrivare sereno alla visita, senza confusione e senza passaggi inutili.",
    percezione: "Elegante, ordinato, affidabile. Il rischio è curare troppo la forma e rimandare decisioni scomode.",
  },
  sociale: {
    label: "Sociale",
    intro: "Sei guidato dal desiderio di aiutare gli altri. Ti motiva sentirti utile, contribuire al benessere comune e cooperare per raggiungere obiettivi.",
    cosaFare: "Usa empatia e collaborazione come forza. Attento però a non dare per scontato che tutti rispondano alla leva dell'aiuto.",
    cosaDire: "Se non puoi venire, avvisaci dal link: potremo offrire il posto a un altro paziente in attesa.",
    percezione: "Umano, etico, collaborativo. Il rischio è evitare regole chiare per non sembrare duro.",
  },
  tradizionale: {
    label: "Tradizionale",
    intro: "Sei guidato dal desiderio di ordine e struttura. Ti rassicurano procedure, routine, punti saldi, sicurezza e metodi di lavoro chiari.",
    cosaFare: "Dai regole semplici e coerenti. La struttura aiuta moltissimo, ma deve restare umana e non trasformarsi in rigidità.",
    cosaDire: "Per organizzare al meglio le visite, chiediamo conferma entro 48 ore.",
    percezione: "Serio, strutturato, professionale. Il rischio è sembrare freddo se il paziente ha bisogno di sentirsi ascoltato.",
  },
};

// Somma le 2 domande di ogni motivazione → [dominante, seconda]
export function computeQuizResult(answers) {
  const scores = {};
  QUIZ_QUESTIONS.forEach((q) => {
    scores[q.motivation] = (scores[q.motivation] || 0) + (answers[q.id] || 0);
  });
  const ranked = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  return { scores, dominant: ranked[0][0], second: ranked[1][0] };
}
